import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence, delay } from "framer-motion";
import "./home.scss";
import PartOne from "./partOne/PartOne";
import PartTwo from "./partTwo/PartTwo";
import PartThree from "./partThree/PartThree";
import PartFour from "./partFour/PartFour";
import PartFive from "./partFive/PartFive";
import Header from '../../components/header/Header';
import { message } from "antd";
import { useLocation, useNavigate } from 'react-router-dom';
import ScreenTip from "../../components/home-screen-tip/ScreenTip"

// 5个页面的配置数据
const pages = [
  {
    id: 1,
    bg: "url(https://oss.tnworld.cn/eastern/assets/home/home-bg.jpg)",
    content: (
      <>
        <PartOne></PartOne>
      </>
    ),
  },
  {
    id: 2,
    // bg: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    bg: "url(https://oss.tnworld.cn/eastern/assets/qhc/qhc-bg.jpg)",
    content: (
      <>
        <PartFour></PartFour>
      </>
    ),

  },
  {
    id: 3,
    bg: "url(https://oss.tnworld.cn/eastern/assets/zgj/zgj-bg.jpg)",
    content: (
      <>
        <PartFive></PartFive>
      </>
    )

  },
  {
    id: 4,
     bg: "url(https://oss.tnworld.cn/eastern/assets/cjy/cjy-bg.jpg)",
    content: (
      <>
        <PartThree></PartThree>
      </>
    ),
   
  },
  {
    id: 5,
     bg: "url(https://oss.tnworld.cn/eastern/assets/jtl/jtl-bg.jpg)",
    content: (
      <>
        <PartTwo></PartTwo>
      </>
    ),
  },
];

const MultiPageTransition = () => {
  // const [[currentPage, direction], setPage] = useState([0, 0]); // [当前页码, 方向(1前进/-1后退)]
  const [activeTab, setActiveTab] = useState('part-1'); // 新增状态来跟踪当前活动的标签页
  const [currentPage, setCurrentPage] = useState(0);
  const [direction, setDirection] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const containerRef = useRef(null);
  const isSwitching = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(false);


  // 滚动阈值（像素）
  const SCROLL_THRESHOLD = 1000;
  const paginate = (newDirection: any) => {
    if (isSwitching.current) return;
    const newPage = currentPage + newDirection;
    if (newPage >= 0 && newPage < pages.length) {
      isSwitching.current = true;
      console.log("切换到", newPage, isSwitching)
      setCurrentPage(newPage);
      setDirection(newDirection);
      setTimeout(() => {
        isSwitching.current = false;
      }, 2000)
      // setScrollY(0); // 重置滚动距离
    } else if (newPage === pages.length) {
      setPage([0, -1])
    }
  };

  const setPage = ([newPage, newDirection]: any) => {
    if (newPage >= 0 && newPage < pages.length) {
      setCurrentPage(newPage);
      setDirection(newDirection);
      setScrollY(SCROLL_THRESHOLD * newPage + SCROLL_THRESHOLD / 2)
      console.log(newPage, SCROLL_THRESHOLD * newPage + SCROLL_THRESHOLD / 2)
      // setScrollY(0); // 重置滚动距离
    }
  };

  useEffect(() => {
    // 从location.state中获取page参数
    const page = location.state?.page;

    if (page) {
      // 如果state中有page参数，调用switchPage
      setPage([page, 1]);
    } else {
      // 如果没有page参数，可以设置默认值
      setPage([0, 1]); // 默认第一页
    }
  }, [location.state]); // 依赖location.state变化

  useEffect(() => {
    setMobile(typeof window.orientation !== "undefined" ||
      navigator.userAgent.indexOf("IEMobile") !== -1 ||
      navigator.userAgent.indexOf("iPhone") !== -1 ||
      (navigator.userAgent.indexOf("Android") !== -1 &&
        navigator.userAgent.indexOf("Mobile") !== -1) ||
      navigator.userAgent.indexOf("BlackBerry") !== -1 ||
      navigator.userAgent.indexOf("Opera Mini") !== -1);
  }, [])


  // 滚轮事件监听
  useEffect(() => {
    const handleWheel = (e: any) => {
      e.preventDefault();
      // console.log(isSwitching.current)
      if (isSwitching.current) return

      // 更新滚动距离
      const newScrollY = scrollY + e.deltaY;
      setScrollY(newScrollY);
      // console.log(newScrollY, currentPage, (SCROLL_THRESHOLD * (currentPage + 1)))
      // 检查是否超过阈值
      // if (Math.abs(newScrollY) >= SCROLL_THRESHOLD) {
      //   if (newScrollY > 0 && currentPage < pages.length - 1) {
      //     paginate(1); // 向下滚动超过阈值，下一页
      //   } else if (newScrollY < 0 && currentPage > 0) {
      //     paginate(-1); // 向上滚动超过阈值，上一页
      //   }
      // }
      if (newScrollY <= 0) {
        setScrollY(0);
      }
      if (newScrollY >= (SCROLL_THRESHOLD * (currentPage + 1))) {
        // console.log("下一页")
        paginate(1);
      } else if (newScrollY > 0 && newScrollY < (SCROLL_THRESHOLD * (currentPage))) {
        // console.log("上一页")
        paginate(-1);
      }

    };

    const container: any = containerRef.current;
    container.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, [currentPage, pages.length, scrollY]);

  // 动画配置
  const variants: any = {
    enter: (direction: any) => ({
      opacity: 0,
      transition: { duration: 0.3 },
    }),
    center: {
      opacity: 1,
      transition: { duration: 2 },
    },
    exit: (direction: any) => ({
      opacity: 0, // 退出时停留在 50% 透明度
      transition: {
        duration: 1,
        // delay: direction > 0 ? 0 : 0.25 // 方向不同时延迟不同
      },
    }),
  };

  const handleNavClick = (type: string, ip: number) => {
    switch (type) {
      case 'home':
        setPage([0, 0 > currentPage ? 1 : -1]);
        break;
      case "verse":
        // window.open(`https://${ip}`, "_blank");
        if (ip === -1) {
          setPage([1, 1 > currentPage ? 1 : -1]);
        } else {
          switch (ip) {
            case 0:
              navigate("/scene?scene=qinghuaci")
              break;
            case 1:
              navigate("/scene?scene=zhongguojie")
              break;
            case 2:
              navigate("/scene?scene=cuojinyin")
              break;
            case 3:
              navigate("/scene?scene=jingtailan")
              break;

            default:
              message.warning("敬请期待");
              break;
          }
        }
        break;
      case "detail":
        // message.success("跳转IP详情页面");
        if (ip === -1) {
          navigate("/detail")
        } else {
          navigate("/detail", { replace: true, state: { ip: ip } })
        }
        break;
      case "about":
        // message.success("跳转我们");
        navigate("/about");
        break;
    }
    // const ref = refs[id];
    // if (ref && ref.current) {
    //   const position = ref.current.offsetTop;
    //   scrollToPosition(position);
    //   setActiveTab(id); // 点击导航时也更新活跃标签页
    // }
  };

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {mobile && <ScreenTip />}
      <Header onNavClick={handleNavClick} activeTab={activeTab} /> {/* 将活跃标签页传递给Header */}
      {/* 页面容器 */}
      <AnimatePresence mode={"popLayout"} custom={direction} initial={true}>
        <motion.div
          key={pages[currentPage].id}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          className="page-container-home"
          onClick={() => { paginate(1) }}
          style={{
            backgroundImage: pages[currentPage].bg,
          }}
        >
          {pages[currentPage].content}
          {/* 滚动进度指示器 */}
          <div style={{
            position: 'absolute',
            right: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            height: '200px',
            width: '4px',
            background: 'rgba(255,255,255,0.3)',
            borderRadius: '2px'
          }}>
            <div style={{
              height: `${Math.min(100, Math.abs(scrollY - (SCROLL_THRESHOLD * currentPage + 1)) / SCROLL_THRESHOLD * 100)}%`,
              width: '100%',
              background: 'white',
              borderRadius: '2px',
              transform: scrollY > 0 ? 'scaleX(1)' : 'scaleX(-1)',
              transformOrigin: 'center top'
            }} />
          </div>
        </motion.div>
      </AnimatePresence>

      {/* 底部进度条 */}
      {/* <div
        style={{
          position: "fixed",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          height: "4px",
          width: "200px",
          background: "rgba(255,255,255,0.3)",
          borderRadius: "2px",
          zIndex: 100,
          cursor: "pointer",
        }}
        onClick={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          const clickPosition = e.clientY - rect.top;
          const progress = clickPosition / rect.height;
          const newPage = Math.floor(progress * pages.length);
          setPage([newPage, newPage > currentPage ? 1 : -1]);
        }}
      >
        <motion.div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: `${(currentPage / (pages.length - 1)) * 100}%`,
            background: "white",
            borderRadius: "2px",
          }}
          animate={{
            width: `${(currentPage / (pages.length - 1)) * 100}%`,
          }}
          transition={{ type: "spring", damping: 10 }}
        />
      </div> */}

      {/* 控制按钮 */}
      {/* <div
        style={{
          position: "fixed",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "10px",
          zIndex: 100,
        }}
      >
        <button
          onClick={() => paginate(-1)}
          disabled={currentPage === 0}
          style={{
            padding: "10px 20px",
            background: "rgba(0,0,0,0.5)",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: currentPage === 0 ? "not-allowed" : "pointer",
          }}
        >
          上一页
        </button>
        <button
          onClick={() => paginate(1)}
          disabled={currentPage === pages.length - 1}
          style={{
            padding: "10px 20px",
            background: "rgba(0,0,0,0.5)",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor:
              currentPage === pages.length - 1 ? "not-allowed" : "pointer",
          }}
        >
          下一页
        </button>
      </div> */}

      {/* 页码指示器 */}
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "10px",
          zIndex: 100,
        }}
      >
        {pages.map((_, index) => (
          <div
            key={index}
            style={{
              width: "50px",
              height: "4px",
              borderRadius: "10px",
              background:
                currentPage === index ? "white" : "rgba(255,255,255,0.3)",
              cursor: "pointer",
            }}
            onClick={() => setPage([index, index > currentPage ? 1 : -1])}
          />
        ))}
      </div>
    </div>
  );
};

export default MultiPageTransition;
